import component from './Loading'

export default component
